<div class="padding-20 ui-g" *ngIf="show.form" id="fruitionConditionsCouponForm">
  <br />
  <br />
  <div class="ui-g-12">
    <div class="ui-g ui-g-8">

      <!-- riga -->
      <div class="ui-g-6">

        <!-- combo modalità di inizio fruizione -->
        <app-form-fields #tipoSogliaFruizione data-testid="tipoSogliaFruizione" [readOnly]="readOnly"
          [fieldSchema]="formSchema.form.tipo_soglia_fruizione" [(fieldModel)]="fieldModel.tipoSogliaFruizione"
          [type]="'dropdown'" [placeholder]="'campaign.select_threshold_type' | translate"></app-form-fields>

      </div>
      <div class="ui-g-4">
        <app-form-fields #sogliaFruizione data-testid="sogliaFruizione" [readOnly]="readOnly"
          [fieldSchema]="formSchema.form.soglia_fruizione" [(fieldModel)]="fieldModel.sogliaFruizione"
          [type]="'number'"></app-form-fields>

      </div>
      <div class="ui-g-2"></div>

      <!-- riga -->
      <div class="ui-g-12" *ngIf="!disabledSwitch.gestioneAccumulatori">
        <br />
        <br />

        <app-form-fields #switchGestioneAccumulatoriFruizione data-testid="switchGestioneAccumulatoriFruizione"
          [readOnly]="readOnly" [fieldSchema]="formSchema.form.switch_gestione_accumulatori"
          (fieldModelChange)="onChangeGestioneAccumulatoriFruizione($event)"
          [(fieldModel)]="switch.gestioneAccumulatori"></app-form-fields>
      </div>

    
          <!-- Accumulatori da Movimentare-->
      <div class="ui-g-12 accumulatoriDaRiutilizzare"
        *ngIf="switch.gestioneAccumulatori && !disabledSwitch.gestioneAccumulatori ">
        <br />
        <br />
        <div class="title">{{ 'campaign.accumulators_to_use' | translate }}</div>
        <br />
        <div class="listaAccumulatoriDaUtilizzare"
          *ngIf="fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare.length>0">
          <br />
          <table id="tableListaAccumulatori">
            <thead>
              <tr>
                <th><i class="pi pi-lock-open"></i></th>
                <th>{{ 'campaign.channel' | translate }}</th>
                <th>{{ 'campaign.accumulator' | translate }}</th>
                <th>{{ 'campaign.code' | translate }}</th>
                <th>{{ 'common.reason' | translate }}</th>
                <th>{{ 'campaign.value' | translate }}</th>
                <th>{{ 'campaign.operation' | translate }}</th>

              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let acm of fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare;let i=index;">
                <td><i *ngIf="!readOnly" class="fa fa-trash pointer" (click)="onDeleteAcmFromList(i)"></i></td>
                <td>{{acm.channelDescription}}</td>
                <td>{{acm.acmDescription}}</td>
                <td>{{acm.acm_code}}</td>
                     <td>
                  <app-form-fields [readOnly]="readOnly" [fieldSchema]="formSchema.form.accumulatore_causale"
                    #acm_reaspm data-testid="acm_reason" [placeholder]="'card.selectBlacklistReason' | translate"
                    [showLabel]="false" [(fieldModel)]="acm.c3AcmReason" [type]="'dropdown'" [options]="reasonItems"
                    [optionLabel]="'label'" [required]="true"   (fieldModelChange)="onReasonSelected($event, i)"></app-form-fields>

                </td>
                <td>
                  <app-form-fields [readOnly]="readOnly" [fieldSchema]="formSchema.form.accumulatore_valore" #acm_value
                    data-testid="acm_value" [(fieldModel)]="acm.c3AcmValue" [showLabel]="false"
                    [type]="'number'"[required]="true"></app-form-fields>
                </td>
          
                 <td>
                  <app-form-fields [readOnly]="readOnly" [fieldSchema]="formSchema.form.accumulatore_operazione"
                    #acm_operation data-testid="acm_operation" [placeholder]="'campaign.select_operation' | translate"
                    [showLabel]="false" [(fieldModel)]="acm.c3AcmOperation" [type]="'dropdown'" [required]="true"
                    (fieldModelChange)="onOperationSelected($event)"[disabled]="true"></app-form-fields>
                </td>
             
                 
               <!--  <td><i class="fa fa-info-circle icon"
                    pTooltip="Id {{acm.id}} &#13; Data di inizio {{acm.dateStart | date: srvCalTranslate.pcalendarTranslate.dateFormatFilter}}  &#13; Data di fine {{acm.dateEnd | date: srvCalTranslate.pcalendarTranslate.dateFormatFilter}}"></i>
                </td> -->
              </tr>
            </tbody>
          </table>
          <br />
        </div>
        <div class="addButton" *ngIf="!readOnly">
          <div class="pointer fa fa-plus circleIcon" (click)="onClickAddAccumulatori()"></div>
          <span class="add-label">Aggiungi Accumulatore</span>
        </div>

           <div class="mode-toggle">
          <button [class.active]="selectedMode" (click)="selectedMode = true">
            Gestione Koncentro
          </button>
          <button [class.active]="!selectedMode" (click)="selectedMode = false">
            Gestione FE
          </button>
        </div>
      </div>




      <!-- Accumulatori da Controllare-->
      <div class="ui-g-12 accumulatoriDaRiutilizzare"
        *ngIf="switch.gestioneAccumulatori && !disabledSwitch.gestioneAccumulator && formSchema.form.accumulatori_regole_avanzate.visible">
        <br />
        <br />
        <div class="title">{{ 'campaign.accumulators_rules' | translate }}</div>
        <br />

        <div class="and-or-toggle">
          <button [class.active]="useAnd" (click)="useAnd = true">
            AND
          </button>
          <button [class.active]="!useAnd" (click)="useAnd = false">
            OR
          </button>
        </div>
        <div class="listaAccumulatoriDaUtilizzare" *ngIf="fieldModel.gestioneAccumulatori.regoleAvanzate.length>0">
          <br />
          <table id="tableRegoleAvanzate">
            <thead>
              <tr>
                <th><i class="pi pi-lock-open"></i></th>
                <th>{{ 'campaign.channel' | translate }}</th>
                <th>{{ 'campaign.accumulator' | translate }}</th>
                <th>{{ 'campaign.code' | translate }}</th>
                <th>{{ 'campaign.operation' | translate }}</th>
                <th>{{ 'campaign.value' | translate }}</th>
 
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let acm of fieldModel.gestioneAccumulatori.regoleAvanzate;let i=index;">
                <td><i *ngIf="!readOnly" class="fa fa-trash pointer" (click)="onDeleteAcmFromRuleList(i)"></i></td>
                <td>{{acm.channelDescription}}</td>
                <td>{{acm.acmDescription}}</td>
                <td>{{acm.acm_code}}</td>
            <td>
              <app-form-fields [readOnly]="readOnly" [fieldSchema]="formSchema.form.accumulatore_regole_operatore" #acm_rule_operator
                data-testid="acm_rule_operator" [placeholder]="'campaign.select_operation' | translate" [showLabel]="false" [required]="true"
                [(fieldModel)]="acm.c3AcmRuleOperator" [type]="'dropdown'"></app-form-fields>
            </td>
            <td>
              <app-form-fields [readOnly]="readOnly" [fieldSchema]="formSchema.form.accumulatore_regole_valore" #acm_rule_value
                data-testid="acm_rule_value"  [required]="true" [(fieldModel)]="acm.c3AcmRuleValue" [showLabel]="false" [type]="'number'"></app-form-fields>
            </td>

              </tr>
            </tbody>
          </table>
          <br />
        </div>
        <div class="addButton" *ngIf="!readOnly">
          <div class="pointer fa fa-plus circleIcon" (click)="onClickAddAccumulatoriForRules()"></div>
          <span class="add-label">Aggiungi Regole Avanzate</span>
        </div>

      </div>


    </div>
    <div class="ui-g-4">
      <div class="ui-g-12">
        <div class="numeroUtilizziContainer ui-g">
          <div class="ui-g-12 numeroUtilizziTitle">{{formSchema.form.numero_utilizzi.label[language]}}<span
              class="asterix">*</span></div>
          <div class="ui-g-4">
            <app-form-fields #utilizziNumero data-testid="utilizziNumero" [readOnly]="readOnly" [showLabel]="false"
              [fieldSchema]="formSchema.form.numero_utilizzi" [(fieldModel)]="fieldModel.utilizziCoupon.numero"
              [type]="'number'" (fieldModelChange)="onChangeNumeroCoupon()"></app-form-fields>
          </div>
          <div class="ui-g-8">
            <app-form-fields #utilizziTipo data-testid="utilizziTipo" [readOnly]="readOnly"
              [fieldSchema]="formSchema.form.modalita_utilizzo" [(fieldModel)]="fieldModel.utilizziCoupon.tipo"
              [type]="'dropdown'"></app-form-fields>
          </div>

        </div>
      </div>

      <div class="ui-g-12">
        <br />
        <br />
        <app-form-fields #switchLimitiFruizione data-testid="switchLimitiFruizione" [readOnly]="readOnly"
          [fieldSchema]="formSchema.form.switch_limiti_fruizione" (fieldModelChange)="onChangeLimitiFruizione($event)"
          [(fieldModel)]="switch.limitiFruizione"></app-form-fields>
      </div>
      <div class="ui-g ui-g-12" *ngIf="switch.limitiFruizione">

        <div class="ui-g-12">
          <div class="limiteFruizioneContainer" *ngIf="switch.limitiFruizione">
            <app-form-fields #maxFruizioniTotali data-testid="maxFruizioniTotali" [readOnly]="readOnly"
              [fieldSchema]="formSchema.form.num_max_fruizioni_totali_cliente"
              [(fieldModel)]="fieldModel.limitiFruizione.maxFruizioniTotali" [type]="'number'"></app-form-fields>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="limiteFruizioneContainer" *ngIf="switch.limitiFruizione">
            <app-form-fields #maxTransazioniCliente_fruizione data-testid="maxTransazioniCliente_fruizione"
              [readOnly]="readOnly" [fieldSchema]="formSchema.form.num_max_transazioni_cliente"
              [(fieldModel)]="fieldModel.limitiFruizione.maxTransazioniCliente" [type]="'number'"></app-form-fields>
          </div>
        </div>

        <div class="ui-g-12">
          <div class="limiteFruizioneContainer" *ngIf="switch.limitiFruizione">
            <app-form-fields #maxFruizioniClienteTransazioni data-testid="maxFruizioniClienteTransazioni"
              [readOnly]="readOnly" [fieldSchema]="formSchema.form.num_max_fruizioni_cliente_transazione"
              [(fieldModel)]="fieldModel.limitiFruizione.maxFruizioniClienteTransazioni"
              [type]="'number'"></app-form-fields>
          </div>
        </div>

        <!-- AGGIUNTA A SEGUITO DI CALL 02/04/2024 (vedi commenti issue KS-5417 e KS-5418) -->
        <div class="ui-g-12">
          <div class="limiteFruizioneContainer" *ngIf="switch.limitiFruizione">
            <app-form-fields #modoCalcoloSogliaFruizione data-testid="modoCalcoloSogliaFruizione" [readOnly]="readOnly"
              [fieldSchema]="formSchema.form.modo_calcolo_soglia"
              [placeholder]="'campaign.select_operation' | translate" 
              [(fieldModel)]="fieldModel.limitiFruizione.modoSogliaFruizione" [type]="'dropdown'"></app-form-fields>

          </div>
        </div>

      </div>
    </div>

<!--     <p-dialog *ngIf="show.modalAcmList && messageInstanceObject" [width]="1500" [height]="800"
      [(visible)]="show.modalAcmList" [responsive]="true" [header]=" 'campaign.search_accumulators_fruition' | translate "
      showEffect="fade"
      [modal]="true">

      <app-campaign-3-search-accumulators #searchAccumulatorsFruition data-testid="searchAccumulatorsFruition"
        [accumulatorList]="listAccumulatorModelFruition" [dateStart]="messageInstanceObject.startFruitionDate"
        [dateEnd]="messageInstanceObject.endFruitionDate"
        (acmSelected)="onAcmSelected($event)"></app-campaign-3-search-accumulators>

    </p-dialog> -->





  <!-- Gestione accumulatori -->
  <p-dialog *ngIf="show.modalAcmList && messageInstanceObject" [width]="1500" [height]="800"
    [(visible)]="show.modalAcmList" [responsive]="true" [header]="'campaign.search_accumulators_fruition' | translate "
    showEffect="fade" [modal]="true">

    <app-campaign-3-search-accumulators #searchAccumulators [multipleselection]="true"
      [accumulatorList]="listAccumulatorModelFruition" [dateStart]="messageInstanceObject.startFruitionDate"
      [dateEnd]="messageInstanceObject.endFruitionDate"
      (acmSelected)="onAcmSelected($event)"></app-campaign-3-search-accumulators>

  </p-dialog>



  <!-- Gestione regole -->
  <p-dialog *ngIf="show.modalAcmListForRules && messageInstanceObject" [width]="1500" [height]="800"
    [(visible)]="show.modalAcmListForRules" [responsive]="true"
    [header]="'campaign.search_accumulators_fruition' | translate " showEffect="fade" [modal]="true">
  
    <app-campaign-3-search-accumulators #searchAccumulatorsForRules [multipleselection]="false"
      [accumulatorList]="listAccumulatorModelFruitionForRules" [dateStart]="messageInstanceObject.startFruitionDate"
      [dateEnd]="messageInstanceObject.endFruitionDate"
      (acmSelected)="onAcmSelectedForRules($event)"></app-campaign-3-search-accumulators>
  
  </p-dialog>

    
  </div>


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/views/campaign-3-fruition-conditions/campaign-3-fruition-conditions.component.html